import { render, staticRenderFns } from "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=template&id=398401e2&scoped=true&"
import script from "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=script&lang=js&"
export * from "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=script&lang=js&"
import style0 from "./monitoring.coreos.com.alertmanagerconfig.vue?vue&type=style&index=0&id=398401e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398401e2",
  null
  
)

export default component.exports